<template>
  <JobCostBreakdown :job-id="jobId">
    <span
      class="cursor-help underline decoration-dotted"
      tabindex="0"
      data-cy="job-cost-total"
    >
      {{ label }}
    </span>
  </JobCostBreakdown>
</template>

<script setup lang="ts">
import JobCostBreakdown from "@/Reports/JobCostBreakdown.vue";

// The COGS cell (labor, parts and finance fee), broken down on hover.
defineProps<{ jobId: number; label: string }>();
</script>
